import { API_V4 } from "@/services/config/auth-axios";

class RedeemService {
  baseUrl = "api-redeem/useCode";
  use(code) {
    return API_V4.post(
      `/${this.baseUrl}`,
      { code },
      {
        headers: {
          Language: "fa"
        }
      }
    );
  }
}

export default new RedeemService();
